export default {
  title: 'Lyft Settings',
  items: {
    LyftPriceAdditionPercentage: {
      label: 'Additional Price Percentage',
      type: 'integer',
      unit: '%'
    },
    LyftPriceSubstractionPercentage: {
      label: 'Deduction Price Percentage',
      type: 'integer',
      unit: '%'
    },
    LyftDispatchRestrictPercent: {
      label: 'Lyft Assign Price Limit',
      type: 'integer',
      unit: '%'
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/lyft-settings.js